import FormPagar from "./FormPagar";
import { useState } from "react";
import Recibo from "../Recibo";

const Pagar = () => {
  const [recibo, setRecibo] = useState(null);

  return (
    <div className='container pt-5'>
      <div className={"bg-white rounded p-2 " + (!recibo ? " offset-md-3 col-md-6 offset-sm-1 col-sm-10" : "")}>
        <div className='p-4'>
          <h4>Pago voluntario {recibo ? "recibo número " + recibo?.numeroRecibo?.notacionStandard : null}</h4>
          <hr />
          {!recibo ? <FormPagar setRecibo={setRecibo} /> : <Recibo recibo={recibo} setRecibo={setRecibo} />}
        </div>
      </div>
    </div>
  );
};

export default Pagar;
